import SocketService from '@/services/SocketService';

export interface SocketState {
  connected: boolean;
}

export const SocketModule = {
  state: {
    connected: false,
  },
  mutations: {
    setConnected(state: any, connected: boolean) {
      state.connected = connected;
    },
  },
  actions: {
    createWebSocket() {
      SocketService.createWebSocket();
    },
  },
};
